import { CartLinesUpdateEvent } from '@shopify/events';

// Set the upsell product's cart quantity to the clicked tier's quantity, then let Horizon's
// cart plumbing (drawer morph + header bubble) pick up the result via CartLinesUpdateEvent.
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element && event.target.closest('[data-torc-upsell-qty]');
  if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

  const wrapper = button.closest('[data-torc-upsells]');
  const error = wrapper?.querySelector('.torc-upsells__error');
  const variantId = wrapper?.dataset.variantId ?? '';
  const quantity = Number(button.dataset.torcUpsellQty);

  // First existing line takes the whole quantity, any duplicates are cleared;
  // with no line yet, the variant id adds one.
  const [firstKey = variantId, ...otherKeys] = (wrapper?.dataset.lineKeys ?? '').split(',').filter(Boolean);
  /** @type {Record<string, number>} */
  const updates = { [firstKey]: quantity };
  for (const key of otherKeys) updates[key] = 0;

  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  button.setAttribute('aria-busy', 'true');
  if (error) error.hidden = true;

  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'update',
      context: 'cart',
      lines: [{ id: firstKey, quantity }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(`${Theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sections.join(',') }),
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || cart.message || 'Could not update cart');

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'torc-cart-upsells',
        itemCount: quantity,
        sections: cart.sections,
        didError: false,
      },
    });
  } catch (err) {
    deferred.reject(err);
    button.removeAttribute('aria-busy');
    if (error) {
      error.textContent = err instanceof Error ? err.message : 'Could not update cart';
      error.hidden = false;
    }
  }
});
